import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { ConfigurationPersonnelProcedureAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-procedure-assignment/configuration-personnel-procedure-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState {
    procedures: CommonProcedureResponse[]
    personnelProcedureAssignments: ConfigurationPersonnelProcedureAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState => ({
        procedures: [],
        personnelProcedureAssignments: [],
        laboratoryId: store.getters.labId
    })
